import QRCode from "qrcode";

export const CUSTOMER_PRIVACY_CONSENT_VERSION = "2026-05-29.3";

export const normalizeBaseUrl = (origin) => String(origin || "").replace(/\/+$/, "");

export const buildConfirmationUrl = (origin, token, queryKey = "confirmation") => {
  const safeOrigin = normalizeBaseUrl(origin);
  const safeToken = String(token || "").trim();
  if (!safeOrigin || !safeToken) return "";
  return `${safeOrigin}?${queryKey}=${encodeURIComponent(safeToken)}`;
};

export const createQrSvgDataUrl = (text, { quiet = 4, color = "#000000" } = {}) => {
  const value = String(text || "").trim();
  if (!value) return "";
  const qr = QRCode.create(value, { errorCorrectionLevel: "Q" });
  const size = qr.modules.size;
  const cells = [];
  for (let y = 0; y < size; y += 1) {
    for (let x = 0; x < size; x += 1) {
      if (qr.modules.get(x, y)) {
        cells.push(`<rect x="${x + quiet}" y="${y + quiet}" width="1" height="1"/>`);
      }
    }
  }
  const total = size + quiet * 2;
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${total} ${total}" shape-rendering="crispEdges"><rect width="${total}" height="${total}" fill="#fff"/><g fill="${color}">${cells.join("")}</g></svg>`;
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
};

export const hasReusablePrivacyConsent = (booking = {}) =>
  Boolean(
    booking.customerConfirmationStatus === "accepted" ||
      booking.privacyConsentReused ||
      (booking.confirmationEvents || []).some((event) => event?.type === "privacy_consent")
  );

export const isValidSignatureDataUrl = (value) => {
  const signature = String(value || "").trim();
  return /^data:image\/(png|jpeg|jpg|webp);base64,[A-Za-z0-9+/=]+$/i.test(signature) && signature.length > 500;
};

export const getCustomerSignatureStorageKey = (token) =>
  `teamFraenkelCustomerSignature:${String(token || "").trim().slice(0, 120)}`;

export const shouldWarnMileage = (nextKm, lastKm) => {
  const next = Number(nextKm || 0);
  const last = Number(lastKm || 0);
  return Number.isFinite(next) && Number.isFinite(last) && next > 0 && last > 0 && next < last;
};

export const getFriendlyProcessError = (error, fallback = "Der Vorgang konnte nicht abgeschlossen werden.") => {
  const message = String(error?.message || error || "").toLowerCase();
  if (message.includes("failed to fetch") || message.includes("networkerror")) {
    return "Die Verbindung ist gerade instabil. Bitte WLAN prüfen und den Schritt erneut versuchen.";
  }
  if (message.includes("statement timeout") || message.includes("timeout")) {
    return "Die Datenbank hat zu langsam geantwortet. Bitte kurz warten und den Vorgang in der Historie prüfen.";
  }
  if (message.includes("too many requests")) {
    return "Zu viele Versuche in kurzer Zeit. Bitte eine Minute warten und erneut versuchen.";
  }
  if (message.includes("invalid") && (message.includes("token") || message.includes("uuid"))) {
    return "Der Link oder Vorgang ist ungültig. Bitte in der Annahme neu öffnen oder den aktuellen Link verwenden.";
  }
  return fallback;
};

export const mergeActiveDamageEntries = (centralDamages = [], bookingDamages = []) => {
  const seen = new Set();
  return [...centralDamages, ...bookingDamages].filter((entry) => {
    if (
      !entry ||
      entry.deletedAt ||
      (entry.status && entry.status !== "active")
    ) {
      return false;
    }
    const key = `${entry.url || entry.photoUrl || ""}_${entry.description || ""}`;
    if (seen.has(key)) return false;
    seen.add(key);
    return Boolean(entry.url || entry.photoUrl || entry.description);
  });
};
